var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import WebTraderTemplate from '@front/templates/WebTraderTemplate.html';
import { ControlsUtils } from './ControlsUtils';
import { CustomEvent } from '@shared/utils/CustomEvents';
const mainWindowElementID = 'mainWindow'; // Do we need to unify IDs between WebTraderTemplate and 'el = '#mainWindow'' in NewNetTrader/PortfolioManagement?
class _FullScreenManager {
    constructor() {
        this.AccountLookupDropDownForm = null;
        this.InstrumentLookupDropDownForm = null;
        this.fullscreenExit = new CustomEvent();
        this.IndicatorLookupDropDownForm = null;
        this.showHeaderBackup = null;
        this.cachedTemplateElements = new Map();
    }
    HandleFullscreenChange(event) {
        if (this.IsFullScreenMode) {
            this.handleFullscreenEnter();
        }
        else {
            this.handleFullscreenExit(event);
        }
    }
    get IsFullScreenMode() {
        return document.fullscreenElement != null;
    }
    // Event triggered upon entering Full Screen Mode: document.fullscreenElement contains the div of the Full Screen Mode panel
    handleFullscreenEnter() {
        const fullscreenElement = document.fullscreenElement;
        const mainWindow = document.getElementById(mainWindowElementID);
        if (fullscreenElement != null && mainWindow != null) {
            this.movePopupContainersToFullscreenPanel(fullscreenElement, mainWindow);
            void this.createDropDownFormContainers();
            const fullscreenElementRactive = ControlsUtils.getRactiveFromHTMLElement(fullscreenElement);
            this.showHeaderBackup =
                fullscreenElementRactive == null ? null : fullscreenElementRactive.get('showHeader');
            if (fullscreenElementRactive != null) {
                this.showHeaderBackup = fullscreenElementRactive.get('showHeader');
                void fullscreenElementRactive.set('showHeader', false);
            }
            else {
                this.showHeaderBackup = null;
            }
        }
    }
    // Event triggered upon exiting Full Screen Mode: document.fullscreenElement === null already
    handleFullscreenExit(event) {
        const fullscreenElement = event.target;
        const mainWindow = document.getElementById(mainWindowElementID);
        if (fullscreenElement != null && mainWindow != null) {
            this.removeContainersFromFullscreenPanel(fullscreenElement, mainWindow);
            this.removeDropDownFormContainers();
            this.fullscreenExit.Raise();
            if (this.showHeaderBackup !== null) {
                const fullscreenElementRactive = ControlsUtils.getRactiveFromHTMLElement(fullscreenElement);
                if ((fullscreenElementRactive === null || fullscreenElementRactive === void 0 ? void 0 : fullscreenElementRactive.set) != null) {
                    void fullscreenElementRactive.set('showHeader', this.showHeaderBackup);
                }
            }
        }
    }
    // Adding to panel that is in FullScreenMode 'containers' for account/instrument/etc. dropDownForms
    createDropDownFormContainers() {
        return __awaiter(this, void 0, void 0, function* () {
            const [{ TerceraAccountLookupDropDownForm }, { TerceraInstrumentLookupDropDownForm }, { TerceraIndicatorLookupDropDownForm }] = yield Promise.all([
                import('../elements/Lookup/TerceraAccountLookupDropDownForm'),
                import('../elements/Lookup/TerceraInstrumentLookupDropDownForm'),
                import('../elements/Lookup/TerceraIndicatorLookupDropDownForm')
            ]);
            this.AccountLookupDropDownForm = yield TerceraAccountLookupDropDownForm.createInstance();
            this.InstrumentLookupDropDownForm = yield TerceraInstrumentLookupDropDownForm.createInstance();
            this.IndicatorLookupDropDownForm = yield TerceraIndicatorLookupDropDownForm.createInstance();
        });
    }
    // Adding all (such as tooltipContainer, contextMenuContainer etc.) from WebTraderTemplate.html exclude <div id="mainWindow">
    movePopupContainersToFullscreenPanel(fullscreenElement, mainWindow) {
        const popupContainers = WebTraderTemplate;
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = popupContainers;
        const tempChildren = Array.from(tempContainer.children);
        const mainContainer = mainWindow.parentElement;
        tempChildren.forEach((child) => {
            const id = child.id;
            if (id === mainWindowElementID || id === '') {
                return;
            }
            const existingElement = mainContainer.querySelector(`#${id}`);
            if (existingElement != null) {
                const element = fullscreenElement.appendChild(existingElement);
                this.cachedTemplateElements.set(id, element);
            }
        });
    }
    removeContainersFromFullscreenPanel(fullscreenElement, mainWindow) {
        const mainContainer = mainWindow.parentElement;
        Array.from(this.cachedTemplateElements.keys()).forEach((id) => {
            const existingElement = fullscreenElement.querySelector(`#${id}`);
            if (existingElement != null && mainContainer != null) {
                mainContainer.appendChild(existingElement); // Move existing container of contextMenus/tooltips, etc. back to document.body
                this.cachedTemplateElements.delete(id); // //  After moving, clearing it from cache goes
            }
        });
    }
    removeDropDownFormContainers() {
        if (this.AccountLookupDropDownForm != null) {
            this.AccountLookupDropDownForm.dispose();
        }
        if (this.InstrumentLookupDropDownForm != null) {
            this.InstrumentLookupDropDownForm.dispose();
        }
        if (this.IndicatorLookupDropDownForm != null) {
            this.IndicatorLookupDropDownForm.dispose();
        }
    }
}
export const FullScreenManager = new _FullScreenManager();
